import config, { environmentMap } from '~/constants/config';
import clientSide from '~/helpers/clientSide';

export const get_api_base = (): string => {
  if (!clientSide) {
    return config.api;
  }

  const params = new URLSearchParams(window.location.search);
  const experience = params.get('exp');

  if (experience === 'gateway-test') {
    return environmentMap['gateway-test']?.api || config.api;
  }

  return config.api;
};
